import { React, useEffect } from "react";
import { useDocument } from "../firebase files/hooks/useDocument";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { MDBFooter, MDBContainer, MDBRow, MDBCol } from "mdb-react-ui-kit";
import "./Footer.css";

export default function Footer() {
  // Scroll to the top of the page whenever the location changes start
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  const { document, error } = useDocument("settings", "organisation");

  const { document: appTypeDocument, error: appTypeDocumentError } =
    useDocument("settings", "AppType");

  const { document: socialMedia, error: socialMediaError } = useDocument(
    "settings",
    "socialmedia"
  );

  const { document: pageControlDoc, error: pageControlDocError } = useDocument(
    "settings",
    "pagesControl"
  );

  const {
    document: dbTemplatesPaletteDocuments,
    error: dbTemplatesPaletteError,
  } = useDocument("settings", "themePalette");

  // Get the current year
  const currentYear = new Date().getFullYear();
  return (
    <MDBFooter
      style={{
        // backgroundColor: "var(--white-color)",
        padding: "20px",
        color: "var(--white-color)",
        borderTop: "1px solid #898989",
        position: "absolute",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",

        background:
          dbTemplatesPaletteDocuments &&
          dbTemplatesPaletteDocuments.activeThemePalette ===
            "diwaliThemePalette"
            ? "linear-gradient(to right, #F57000, #F5BF00)"
            : dbTemplatesPaletteDocuments &&
              dbTemplatesPaletteDocuments.activeThemePalette ===
                "defaultThemePalette"
            ? "var(--page-bg)"
            : dbTemplatesPaletteDocuments &&
              dbTemplatesPaletteDocuments.activeThemePalette ===
                "holiThemePalette"
            ? `radial-gradient(circle at 10% 20%, rgba(255, 0, 0, 1), transparent 20%),
           radial-gradient(circle at 80% 30%, rgba(0, 255, 0, 1), transparent 20%),
           radial-gradient(circle at 40% 70%, rgba(0, 0, 255, 1), transparent 20%),
           radial-gradient(circle at 90% 80%, rgba(255, 255, 0, 1), transparent 20%),
           radial-gradient(circle at 30% 90%, rgba(255, 165, 0, 1), transparent 20%),
           radial-gradient(circle at 20% 50%, rgba(255, 0, 255, 1), transparent 15%),
           radial-gradient(circle at 70% 40%, rgba(0, 255, 255, 1), transparent 25%),
           radial-gradient(circle at 50% 50%, rgba(255, 192, 203, 1), transparent 30%),
           radial-gradient(circle at 60% 60%, rgba(173, 216, 230, 1), transparent 25%),
           radial-gradient(circle at 85% 20%, rgba(255, 223, 186, 1), transparent 20%)`
            : dbTemplatesPaletteDocuments &&
              dbTemplatesPaletteDocuments.activeThemePalette ===
                "womenDayThemePalette"
            ? `linear-gradient(135deg, rgb(255, 105, 180), rgb(255 93 180), rgb(255, 192, 203), rgb(255, 182, 193))`
            : null,
      }}
      className="text-center text-lg-start text-muted"
    >
      <section className="text-color d-flex justify-content-center justify-content-lg-between border-bottom">
        <div className="me-5 d-none d-lg-block">
          <span style={{ color: "#ffffff", fontWeight: "700" }}>
            Get connected with us on {document && document.short_name}
          </span>
        </div>

        <div className="d-flex">
          {/* FACEBOOK */}
          {socialMedia && socialMedia.socialmedia.facebook != "" && (
            <div style={{ width: "25px", margin: "0px 5px" }}>
              <a
                href={socialMedia && socialMedia.socialmedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
                style={{ cursor: "pointer" }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path
                    d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h98.2V334.2H109.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H255V480H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
                    fill="#ffffff"
                  />
                </svg>
              </a>
            </div>
          )}

          {/* LINKEDIN */}
          {socialMedia && socialMedia.socialmedia.linkedin != "" && (
            <div style={{ width: "25px", margin: "0px 5px" }}>
              <a
                href={socialMedia && socialMedia.socialmedia.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                style={{ cursor: "pointer" }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path
                    d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                    fill="#ffffff"
                  />
                </svg>
              </a>
            </div>
          )}

          {/* INSTAGRAM */}
          {socialMedia && socialMedia.socialmedia.instagram != "" && (
            <div style={{ width: "25px", margin: "0px 5px" }}>
              <a
                href={socialMedia && socialMedia.socialmedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                style={{ cursor: "pointer" }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path
                    d="M194.4 211.7a53.3 53.3 0 1 0 59.3 88.7 53.3 53.3 0 1 0 -59.3-88.7zm142.3-68.4c-5.2-5.2-11.5-9.3-18.4-12c-18.1-7.1-57.6-6.8-83.1-6.5c-4.1 0-7.9 .1-11.2 .1c-3.3 0-7.2 0-11.4-.1c-25.5-.3-64.8-.7-82.9 6.5c-6.9 2.7-13.1 6.8-18.4 12s-9.3 11.5-12 18.4c-7.1 18.1-6.7 57.7-6.5 83.2c0 4.1 .1 7.9 .1 11.1s0 7-.1 11.1c-.2 25.5-.6 65.1 6.5 83.2c2.7 6.9 6.8 13.1 12 18.4s11.5 9.3 18.4 12c18.1 7.1 57.6 6.8 83.1 6.5c4.1 0 7.9-.1 11.2-.1c3.3 0 7.2 0 11.4 .1c25.5 .3 64.8 .7 82.9-6.5c6.9-2.7 13.1-6.8 18.4-12s9.3-11.5 12-18.4c7.2-18 6.8-57.4 6.5-83c0-4.2-.1-8.1-.1-11.4s0-7.1 .1-11.4c.3-25.5 .7-64.9-6.5-83l0 0c-2.7-6.9-6.8-13.1-12-18.4zm-67.1 44.5A82 82 0 1 1 178.4 324.2a82 82 0 1 1 91.1-136.4zm29.2-1.3c-3.1-2.1-5.6-5.1-7.1-8.6s-1.8-7.3-1.1-11.1s2.6-7.1 5.2-9.8s6.1-4.5 9.8-5.2s7.6-.4 11.1 1.1s6.5 3.9 8.6 7s3.2 6.8 3.2 10.6c0 2.5-.5 5-1.4 7.3s-2.4 4.4-4.1 6.2s-3.9 3.2-6.2 4.2s-4.8 1.5-7.3 1.5l0 0c-3.8 0-7.5-1.1-10.6-3.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM357 389c-18.7 18.7-41.4 24.6-67 25.9c-26.4 1.5-105.6 1.5-132 0c-25.6-1.3-48.3-7.2-67-25.9s-24.6-41.4-25.8-67c-1.5-26.4-1.5-105.6 0-132c1.3-25.6 7.1-48.3 25.8-67s41.5-24.6 67-25.8c26.4-1.5 105.6-1.5 132 0c25.6 1.3 48.3 7.1 67 25.8s24.6 41.4 25.8 67c1.5 26.3 1.5 105.4 0 131.9c-1.3 25.6-7.1 48.3-25.8 67z"
                    fill="#ffffff"
                  />
                </svg>
              </a>
            </div>
          )}

          {/* YOUTUBE */}
          {socialMedia && socialMedia.socialmedia.youtube != "" && (
            <div style={{ width: "32px", margin: "0px 5px" }}>
              <a
                href={socialMedia && socialMedia.socialmedia.youtube}
                target="_blank"
                rel="noopener noreferrer"
                style={{ cursor: "pointer" }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                  <path
                    d="M282 256.2l-95.2-54.1V310.3L282 256.2zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm14.4 136.1c7.6 28.6 7.6 88.2 7.6 88.2s0 59.6-7.6 88.1c-4.2 15.8-16.5 27.7-32.2 31.9C337.9 384 224 384 224 384s-113.9 0-142.2-7.6c-15.7-4.2-28-16.1-32.2-31.9C42 315.9 42 256.3 42 256.3s0-59.7 7.6-88.2c4.2-15.8 16.5-28.2 32.2-32.4C110.1 128 224 128 224 128s113.9 0 142.2 7.7c15.7 4.2 28 16.6 32.2 32.4z"
                    fill="#ffffff"
                  />
                </svg>
              </a>
            </div>
          )}

          {/* TWITTER */}
          {socialMedia && socialMedia.socialmedia.twitter != "" && (
            <div style={{ width: "32px", margin: "-2px 0px 0px -6px" }}>
              <a
                href={socialMedia && socialMedia.socialmedia.twitter}
                target="_blank"
                rel="noopener noreferrer"
                style={{ cursor: "pointer" }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path
                    d="M 6 3 C 4.3550302 3 3 4.3550302 3 6 L 3 18 C 3 19.64497 4.3550302 21 6 21 L 18 21 C 19.64497 21 21 19.64497 21 18 L 21 6 C 21 4.3550302 19.64497 3 18 3 L 6 3 z M 6 5 L 18 5 C 18.56503 5 19 5.4349698 19 6 L 19 18 C 19 18.56503 18.56503 19 18 19 L 6 19 C 5.4349698 19 5 18.56503 5 18 L 5 6 C 5 5.4349698 5.4349698 5 6 5 z M 6.7011719 7 L 10.642578 12.632812 L 6.90625 17 L 8.2382812 17 L 11.240234 13.484375 L 13.697266 17 L 17.537109 17 L 13.351562 11.009766 L 16.773438 7 L 15.462891 7 L 12.759766 10.160156 L 10.552734 7 L 6.7011719 7 z M 8.5664062 7.9882812 L 10.052734 7.9882812 L 15.683594 16.011719 L 14.1875 16.011719 L 8.5664062 7.9882812 z"
                    fill="#ffffff"
                  ></path>
                </svg>
              </a>
            </div>
          )}
        </div>
      </section>

      <section className="text-color footer_content_div">
        <MDBContainer className="text-start text-md-start mt-6">
          <MDBRow className="mt-6 ">
            <MDBCol md="3" lg="4" xl="3" className="mx-auto mb-4">
              <h6 className="text-uppercase fw-bold mb-4">
                <img
                  src={document && document.logoUrl}
                  alt="logo"
                  className="footer_logo_design"
                />
                <br />
                {document && document.short_name}
              </h6>
              <p>{document && document.short_details}</p>
            </MDBCol>

            <MDBCol
              md="2"
              lg="2"
              xl="2"
              className="mx-auto mb-4 footer_link_div"
            >
              <h6 className="d-flex align-items-center text-uppercase fw-bold mb-4">
                <div className="footer_headings_vertical_line"></div> Quick
                Links
              </h6>
              <p>
                <Link to="/">Home</Link>
              </p>
              <p>
                <Link to="/faq"> FAQ</Link>
              </p>
              {pageControlDoc && pageControlDoc.career === true && (
                <p>
                  <Link to="/career">Career</Link>
                </p>
              )}

              {pageControlDoc && pageControlDoc.gallery === true && (
                <p>
                  <Link to="/gallery"> Gallery</Link>
                </p>
              )}

              {pageControlDoc && pageControlDoc.career === true && (
                <p>
                  <Link to="/features">Features</Link>
                </p>
              )}

              {pageControlDoc && pageControlDoc.dashboard === true && (
                <>
                  {appTypeDocument &&
                  appTypeDocument.apptype == "lite" ? null : (
                    <>
                      <p>
                        <Link to="/bookinglist">Bookings</Link>
                      </p>
                      <p>
                        <Link to="/customerdashboard"> Dashboard</Link>
                      </p>
                    </>
                  )}
                </>
              )}

              {(appTypeDocument && appTypeDocument.apptype === "liteplus") ||
              (appTypeDocument && appTypeDocument.apptype === "pro") ? (
                <p>
                  <Link to="/notifications"> Noifications</Link>
                </p>
              ) : null}

              {pageControlDoc && pageControlDoc.products === true && (
                <p>
                  <Link to="/products"> Products & Services</Link>
                </p>
              )}
            </MDBCol>

            <MDBCol
              md="3"
              lg="2"
              xl="2"
              className="mx-auto mb-4 footer_link_div"
            >
              <h6 className="d-flex align-items-center text-uppercase fw-bold mb-4">
                <div className="footer_headings_vertical_line"></div> Useful
                Links
              </h6>
              <p>
                <Link to="/aboutus">About Us</Link>
              </p>
              <p>
                <Link to="term-condition">Disclaimer</Link>
              </p>
              <p>
                <Link to="/contact">Contact Us</Link>
              </p>
              {pageControlDoc && pageControlDoc.returnpolicy === true && (
                <p>
                  <Link to="/returnpolicy">Return Policy</Link>
                </p>
              )}
              <p>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </p>
              <p>
                <Link to="/contact"> Help & Support </Link>
              </p>
              <p>
                <Link to="/term-condition"> Terms & Conditions</Link>
              </p>
            </MDBCol>

            <MDBCol md="4" lg="3" xl="3" className="mx-auto mb-md-0 mb-4">
              <h6 className="d-flex align-items-center text-uppercase fw-bold mb-4">
                <div className="footer_headings_vertical_line"></div>Contacts
              </h6>

              <p className="d-flex align-item-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="currentColor"
                >
                  <path d="M360-440h80v-110h80v110h80v-190l-120-80-120 80v190Zm120 254q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" />
                </svg>

                {document?.address && (
                  <a
                    href={`text:${document.address}`}
                    className="ms-2 text-decoration-none"
                    style={{ color: "inherit" }}
                  >
                    {document.address}
                  </a>
                )}
              </p>

              {document && Array.isArray(document.email) ? (
                document.email.map((email, index) => (
                  <p className="d-flex align-items-center" key={index}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="currentColor"
                    >
                      <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z" />
                    </svg>
                    <a
                      href={`mailto:${email}`}
                      className="ms-2 text-decoration-none"
                      style={{ color: "inherit" }}
                    >
                      {email}
                    </a>
                  </p>
                ))
              ) : (
                <p className="d-flex align-items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="currentColor"
                  >
                    <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z" />
                  </svg>
                  {document?.email && (
                    <a
                      href={`mailto:${document.email}`}
                      className="ms-2 text-decoration-none"
                      style={{ color: "inherit" }}
                    >
                      {document.email}
                    </a>
                  )}
                </p>
              )}

              {document && Array.isArray(document.contact_number) ? (
                document.contact_number.map((number, index) => (
                  <p className="d-flex align-items-center" key={index}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="#currentColor"
                    >
                      <path d="M280-40q-33 0-56.5-23.5T200-120v-720q0-33 23.5-56.5T280-920h400q33 0 56.5 23.5T760-840v720q0 33-23.5 56.5T680-40H280Zm0-200v120h400v-120H280Zm200 100q17 0 28.5-11.5T520-180q0-17-11.5-28.5T480-220q-17 0-28.5 11.5T440-180q0 17 11.5 28.5T480-140ZM280-320h400v-400H280v400Zm0-480h400v-40H280v40Zm0 560v120-120Zm0-560v-40 40Z" />
                    </svg>
                    <a
                      href={`tel:${number}`}
                      className="ms-2 text-decoration-none"
                      style={{ color: "inherit" }}
                    >
                      {number}
                    </a>
                  </p>
                ))
              ) : (
                <p className="d-flex align-items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#currentColor"
                  >
                    <path d="M280-40q-33 0-56.5-23.5T200-120v-720q0-33 23.5-56.5T280-920h400q33 0 56.5 23.5T760-840v720q0 33-23.5 56.5T680-40H280Zm0-200v120h400v-120H280Zm200 100q17 0 28.5-11.5T520-180q0-17-11.5-28.5T480-220q-17 0-28.5 11.5T440-180q0 17 11.5 28.5T480-140ZM280-320h400v-400H280v400Zm0-480h400v-40H280v40Zm0 560v120-120Zm0-560v-40 40Z" />
                  </svg>{" "}
                  {document?.contact_number && (
                    <a
                      href={`tel:${document.contact_number}`}
                      className="ms-2 text-decoration-none"
                      style={{ color: "inherit" }}
                    >
                      {document.contact_number}
                    </a>
                  )}
                </p>
              )}
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className="text-color text-center p-4 footer-copyright-div">
        &copy; {currentYear} {document && document.full_name}. All rights
        reserved
        <br />
        <a href="https://www.hyperclouddigital.com/" target="_blank">
          {document && document.copyRightArea ? (
            document.copyRightArea.trim() !== "" ? (
              <>{document.copyRightArea}</>
            ) : (
              <>
                Design & Developed by
                <br />
                Hyper Cloud Digital Solutions
              </>
            )
          ) : (
            <>
              Design & Developed by
              <br />
              Hyper Cloud Digital Solutions
            </>
          )}
        </a>
      </div>
    </MDBFooter>
  );
}
